import Component from '@bythepixel/component-loader';
import { list } from 'cart-localstorage';

export default class CartIcon extends Component {
  static selector = '[data-comp-cart-icon]';

  constructor(containerEl) {
    super(containerEl);
    this.cartCounter = this.$container.querySelector('[data-cart-counter]');
    this.renderCartIcon(list());

    if (!window.CIMARRON) {
      window.CIMARRON = {};
    }

    if (!window.CIMARRON.cartIcons) {
      window.CIMARRON.cartIcons = [];
    }

    window.CIMARRON.cartIcons.push(this);
  }

  renderCartIcon() {
    if (list().length > 0) {
      this.$container.classList.remove('hidden');
      this.cartCounter.innerHTML = list().length;
    } else if (this.$container.classList.contains(this.activeCartIconClass)) {
      this.$container.classList.add('hidden');
    }
  }
}
